import { useLocation } from '@provider/navigation';
import { useComponentEntry } from '@utils/component-framework';

function useCurrentPage(componentData, entryKey) {
  const location = useLocation();
  const initialPageIdFromEntry = useComponentEntry(entryKey, {
    select: entry => entry?.data.currentPageId
  });
  const pathnameSegments = location.pathname.split("/");
  const desiredPageId = location.searchParams.get("pageId") || pathnameSegments[pathnameSegments.length - 1];

  // We prefer to fetch the current task based on the provided location...
  let currentPageIndex = componentData.pages.findIndex(it => it.id === desiredPageId);

  // ... however, if there's no matches, then fall back to the current task
  // for the provided entry, if any.
  if (currentPageIndex === -1 && initialPageIdFromEntry.data) {
    currentPageIndex = componentData.pages.findIndex(it => it.id === initialPageIdFromEntry.data);
  }
  if (currentPageIndex === -1) {
    currentPageIndex = 0;
  }
  return {
    page: componentData.pages[currentPageIndex],
    index: currentPageIndex
  };
}

export { useCurrentPage };
//# sourceMappingURL=hook.current-page.js.map
